/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideToastr } from 'ngx-toastr';
import { AppInitService } from './app/app-init.service';
import { initializeApp } from './app/app-initializer';
import { provideState, provideStore } from '@ngrx/store';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app/app.routes';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { Designreducer } from './app/store/UserThemes/design.reducer';
import { designeffect } from './app/store/UserThemes/design.effect';
import { provideAnimations } from '@angular/platform-browser/animations';
import { GlobalErrorhandelerService } from './app/core/services/global-errorhandeler.service';
import { customInterceptorInterceptor } from './app/core/Interceptor/custom-interceptor.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  provideNativeDateAdapter,
  MatNativeDateModule,
} from '@angular/material/core';
import { MY_DATE_FORMATS } from './app/Shared/Models/MY_DATE_FORMATS';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DatePipe } from '@angular/common';
import { async, ReplaySubject, Subject } from 'rxjs';
import { BranchEffects } from './app/store/Branchmaster/Branchmaster.effects';
import { branchReducer } from './app/store/Branchmaster/Branchmaster.reducer';
import { AirlinelistEffects } from './app/store/AirlinelistMaster/Airlinelist.effects';
import { airlinelistReducer } from './app/store/AirlinelistMaster/Airlinelist.reducer';
import { AirportListEffects } from './app/store/AirportListMaster/Airportlist.effects';
import { airportListReducer } from './app/store/AirportListMaster/Airportlist.reducer';
import { ChannellistEffects } from './app/store/ChannellistMaster/Channellist.effects';
import { channellistReducer } from './app/store/ChannellistMaster/Channellist.reducer';
import { CountryListEffects } from './app/store/CountryListMaster/Countrylist.effects';
import { countryListReducer } from './app/store/CountryListMaster/Countrylist.reducer';
import { ServiceslistEffects } from './app/store/ServiceslistMaster/Serviceslist.effects';
import { serviceslistReducer } from './app/store/ServiceslistMaster/Serviceslist.reducer';
import { SupplierlistEffects } from './app/store/SupplierlistMaster/Supplierlist.effects';
import { supplierlistReducer } from './app/store/SupplierlistMaster/Supplierlist.reducer';
import { groupListReducer } from './app/store/GroupMaster/Grouplist.reducer';
import { GroupListEffects } from './app/store/GroupMaster/Grouplist.effects';
import { agentListReducer } from './app/store/AgentlistMaster/Agentlist.reducer';
import { AgentListEffects } from './app/store/AgentlistMaster/Agentlist.effects';
//import { MY_DATE_FORMATS } from './app/Shared/Components/usr-date-range/usr-date-range.component';
// bootstrapApplication(AppComponent, appConfig).catch((err) =>
//   console.error(err)
// );
bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([customInterceptorInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideStore(),
    provideState({ name: 'designButtonState', reducer: Designreducer }),
    provideEffects([designeffect]),
    provideState({ name: 'branch', reducer: branchReducer }),
    provideEffects([BranchEffects]),
    provideState({ name: 'airlines', reducer: airlinelistReducer }),
    provideEffects([AirlinelistEffects]),
    provideState({ name: 'airportList', reducer: airportListReducer }),
    provideEffects([AirportListEffects]),
    provideState({ name: 'channels', reducer: channellistReducer }),
    provideEffects([ChannellistEffects]),
    provideState({ name: 'countryList', reducer: countryListReducer }),
    provideEffects([CountryListEffects]),
    provideState({ name: 'suppliers', reducer: supplierlistReducer }),
    provideEffects([SupplierlistEffects]),
    provideState({ name: 'services', reducer: serviceslistReducer }),
    provideEffects([ServiceslistEffects]),
    provideState({ name: 'groupList', reducer: groupListReducer }),
    provideEffects([GroupListEffects]),
    provideState({ name: 'agentList', reducer: agentListReducer }),
    provideEffects([AgentListEffects]),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideNativeDateAdapter(), // ✅ Registers DateAdapter
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    importProvidersFrom(
      ReactiveFormsModule,
      MatDatepickerModule,
      MatFormFieldModule,
      MatInputModule,
      MatNativeDateModule,
      ReplaySubject,
      Subject
    ),
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorhandelerService },
    provideAnimations(), // required animations providers
    provideToastr(),
    provideAnimationsAsync(),
    DatePipe, // Toastr providers
  ],
}).catch((err) => console.error(err));
